// import React from 'react'

// function CardItem(props) {


//   return (
//     <>
//     <li
//     className="cards__item"
//     >

//           {/* Front of the card */}
//           <div className="card-front">
//               <figure
//                 className="cards__item__pic-wrap"
//                 data-category={props.label}
//               >
//                 <img
//                   src={props.src}
//                   alt="Service Image"
//                   className="cards__item__img"
//                 />
//               </figure>
//           </div>

//           {/* Back of the card */}
//           <div className="card-back">
//             <div className="cards__item__info">
//               <h5 className="cards__item__text">{props.text}</h5>
//             </div>
//           </div>
//       </li>
//       </>

//   );
// }

// export default CardItem

import {Link} from 'react-router-dom'
import React from 'react'

function CardItem(props) {
  return (
    <>
    <li className='cards__item'>
        <Link className='cards__item__link' to={props.path}>
            <figure className='cards__item__pic-wrap' data-category={props.label}>
                <img src={props.src} alt='Travel Image' className='cards__item__img'/>
            </figure>
            <div className='cards__item__info'>
                <h5 className='cards__item__text'>{props.text}</h5>
            </div>
        </Link>
        </li>
    </>
  )
}

export default CardItem